'use strict';

const getBuyUrlWithShippingOptionData = (buyUrl, shippingOptionData = {}) => {
  const params = [];

  Object.keys(shippingOptionData).forEach(key => {
    const value = shippingOptionData[key];
    if (value) {
      params.push(`${key}=${value}`);
    }
  });

  return `${buyUrl}${buyUrl.indexOf('?') > -1 ? '&' : '?'}${params.join('&')}`;
};

module.exports = getBuyUrlWithShippingOptionData;
